export const coerceIntoArray = <T>(value: T | T[] | undefined = []): T[] =>
  ([] as T[]).concat(value)
